import { createFileRoute } from "@tanstack/react-router";
import { useAdminStats } from "@/hooks/use-admin-users";
import { StatCard, StatCardSkeleton } from "@/components/stat-card";

export const Route = createFileRoute("/_admin/dashboard")({
  component: DashboardPage,
});

function DashboardPage() {
  const { data: stats, isLoading, error } = useAdminStats();

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-700">
        Failed to load statistics: {error.message}
      </div>
    );
  }

  const emailsDeliveryRate =
    stats && stats.emails_sent_total > 0
      ? ((stats.emails_delivered / stats.emails_sent_total) * 100).toFixed(1)
      : "0.0";

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">Dashboard</h1>

      {/* Users Section */}
      <section>
        <h2 className="mb-3 text-lg font-semibold text-slate-700">Users</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {isLoading ? (
            <>
              <StatCardSkeleton />
              <StatCardSkeleton />
            </>
          ) : (
            <>
              <StatCard title="Total Users" value={stats?.users_total ?? 0} />
              <StatCard title="Active Users (30d)" value={stats?.users_active_30d ?? 0} />
            </>
          )}
        </div>
      </section>

      {/* Email Stats Section */}
      <section>
        <h2 className="mb-3 text-lg font-semibold text-slate-700">Email Delivery</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {isLoading ? (
            <>
              <StatCardSkeleton />
              <StatCardSkeleton />
              <StatCardSkeleton />
              <StatCardSkeleton />
            </>
          ) : (
            <>
              <StatCard title="Sent Total" value={stats?.emails_sent_total ?? 0} />
              <StatCard title="Delivered" value={stats?.emails_delivered ?? 0} />
              <StatCard title="Bounced" value={stats?.emails_bounced ?? 0} />
              <StatCard
                title="Delivery Rate"
                value={`${emailsDeliveryRate}%`}
                subtitle="delivered / sent"
              />
            </>
          )}
        </div>
      </section>
    </div>
  );
}
